// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BEBaseElement } from './BEBaseElement';
import { EnumBEType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumBEType';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 实体类型元数据基类 实体类
 * 实体类型元数据基类
 */
export abstract class BETypeElement extends BEBaseElement {
  /** 实体类型 : 实体类型 */
  private _bEType: EnumBEType;

  /** 设置：实体类型 */
  public get bEType() {
    return this._bEType;
  }

  /** 获取：实体类型 */
  public set bEType(value: EnumBEType) {
    this._bEType = value;
  }

  constructor() {
    super();
    this._bEType = EnumBEType.BEEntity;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BETypeElement, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.bEType = element.bEType;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.bEType = json.BEType as EnumBEType;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BEType = this.bEType;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
  }
}
